import * as React from 'react';
import './LogIn.css';

interface IProps {
    OnClick?: () => void;
}

export const BigFooter = ({ OnClick }: IProps) => {

    return (
        <div className="big-footer">
            <div className="big-footer__part">
                <div className="left-part">
                    <div className="column">
                        <div className="column__title">
                            Nasze serwisy
                        </div>
                        <div className="column__list">
                            <a href="https://finezjo.pl/">Finezjo</a>
                            <a href="https://znajdzfizjoterapeute.pl/">Znajdź Fizjoterapeutę</a>
                            <a href="https://portal.kif.info.pl/">Portal Fizjoterapeuty</a>
                            {/* <a href="https://fizja.pl/">Fizja</a> */}
                        </div>
                    </div>

                    <div className="column">
                        {/* <div className="column__title">
                            Bezpieczeństwo w KIF
                        </div>
                        <div className="column__list">
                            <p>O serwisie </p>
                            <p>Bezpieczeństwo danych</p>
                        </div> */}
                    </div>
                </div>
            </div>
            <div className="big-footer__part">
                <div className="right-part">
                    <div className="kif-white-logo" />
                    <p className="description">
                        Bezpieczne logowanie to serwis Krajowej Izby Fizjoterapeutów, który pozwala na bezpieczne zalogowanie i korzystanie z wszystkich serwisów KIF.
                    </p>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Login/BigFooter.tsx